<template>
    <div style="height:100%;overflow-y:auto;">
  <div class="bid-predict-container">
    <div class="page-header">
      <h1 class="page-title">投标预测分析系统</h1>
      <p class="page-subtitle">Bidding Prediction & Analysis</p>
    </div>

    <!-- 配置区域 -->
    <div class="config-section">
      <div class="section-title">
        <Icon type="md-settings" size="20" />
        <span>基础配置</span>
      </div>
      <div class="config-container">
        <!-- 第一排：报价方式 -->
        <div class="config-row">
          <label class="config-label">报价方式</label>
          <RadioGroup v-model="bid_price_type" class="radio-group-custom" @on-change="loadTestData">
            <Radio :label="1" :value="1"><span>金额</span></Radio>
            <Radio :label="2" :value="2"><span>下浮率</span></Radio>
          </RadioGroup>
        </div>

        <!-- 第二排：价格区间和限定价 -->
        <div class="config-row config-row-flex">
          <div class="config-item-inline">
            <label class="config-label">价格区间（万元）</label>
            <div class="input-range">
              <Input number v-model="limit_prices[0]" class="input-custom" placeholder="最低价" />
              <span class="range-separator">-</span>
              <Input number v-model="limit_prices[1]" class="input-custom" placeholder="最高价" />
            </div>
          </div>

          <div class="config-item-inline">
            <label class="config-label">最高限定价</label>
            <Input number v-model="max_price" class="input-custom" placeholder="请输入最高限定价" />
          </div>
        </div>

        <!-- 第三排：基准价计算办法 -->
        <div class="config-row">
          <label class="config-label">基准价计算办法</label>
          <RadioGroup v-model="bid_eval_method" class="radio-group-vertical">
            <Radio :label="1" :value="1">
              <span class="formula-text">公式一: 评标基准价 = 平均值 × B + 意向价 × (1-B)</span>
            </Radio>
            <Radio :label="2" :value="2">
              <span class="formula-text">公式二: 评标基准价 = 平均值 × B1 + 次低价 × B2 + 意向价 × (1-B1-B2)</span>
            </Radio>
          </RadioGroup>
        </div>
      </div>
    </div>

    <!-- 投标单位信息 -->
    <div class="bidders-section">
      <div class="flex-wrap flex-between">
      <div class="section-title">
        <Icon type="md-people" size="20" />
        <span>投标单位信息</span>
      </div>
      <Button icon="md-upload" @click="importExcel">导入Excel</Button>
      </div>
      <div class="table-wrapper" style="height:400px;position:relative;">
        <BaseTable :columns="columns" border :data="bidders" :paged="false" />
      </div>
    </div>

    <!-- 预测分析区域 -->
    <div class="predict-section">
      <div class="section-title">
        <Icon type="md-analytics" size="20" />
        <span>预测分析结果</span>
      </div>
      
      <div class="predict-control">
        <Button type="primary" size="large" @click="startPredict" class="predict-btn">
          <Icon type="md-calculator" size="18" />
          开始测算
        </Button>
      </div>

      <div v-if="predict_data.length > 0" class="results-container">
        <!-- <div class="result-cards">
          <div class="result-card">
            <div class="card-label">投标报价偏离单位</div>
            <div class="card-value">{{ unit }}</div>
          </div>
          <div class="result-card">
            <div class="card-label">平均价格</div>
            <div class="card-value">{{ average_price }}</div>
          </div>
          <div class="result-card" v-if="bid_eval_method==2">
            <div class="card-label">次低投标评审价</div>
            <div class="card-value">{{ next_lowest_price }}</div>
          </div>
        </div> -->
        <div class="predict-table-wrapper">
          <BaseTable :columns="predict_columns" :data="predict_data" :paged="false" :option="{sort_key:'rate',sort_order:'asc'}" border />
        </div>
      </div>
    </div>
    <input
        ref="fileLoader"
        v-show="false"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,*.csv"
        @change="parse"
    />
    </div>
    
    <!-- 详细信息对话框 -->
    <Modal v-model="showDetailModal" :footer-hide="true" width="1200" class-name="bidder-detail-modal">
      <div slot="header" class="modal-header">
        <Icon type="md-analytics" size="24" />
        <span>预测分析详情</span>
      </div>
      <div class="modal-content" v-if="selectedDetail">
        <div class="detail-overview">
          <div class="overview-card">
            <div class="overview-label">权重系数</div>
            <div class="overview-value">{{ (selectedDetail.w * 100).toFixed(0) }}%</div>
          </div>
          <div class="overview-card">
            <div class="overview-label">投标评审价</div>
            <div class="overview-value">{{ formatPrice(selectedDetail.p) }}</div>
          </div>
          <div class="overview-card">
            <div class="overview-label">评标基准价</div>
            <div class="overview-value highlight">{{ formatPrice(selectedDetail.base_price) }}</div>
          </div>
        </div>
        
        <div class="detail-section">
          <div class="detail-section-title">
            <Icon type="md-trophy" size="18" />
            <span>各投标单位得分情况</span>
          </div>
          <div class="detail-table-wrapper">
            <BaseTable 
              :columns="detailColumns" 
              :data="detailTableData" 
              :paged="false" 
              :option="{sort_key:'totalScore',sort_order:'desc'}"
              border 
            />
          </div>
        </div>
        
        <div class="detail-footer">
          <Alert type="info" show-icon>
            <template slot="desc">
              <div class="formula-info">
                <div><strong>计算公式：</strong></div>
                <div v-if="bid_eval_method == 1" class="formula-text-detail">
                  评标基准价 = 平均值 × {{ (selectedDetail.w * 100).toFixed(0) }}% + 意向价 × {{ ((1-selectedDetail.w) * 100).toFixed(0) }}%
                </div>
                <div v-else class="formula-text-detail">
                  评标基准价 = 平均值 × {{ (selectedDetail.w/2 * 100).toFixed(0) }}% + 次低价 × {{ (selectedDetail.w/2 * 100).toFixed(0) }}% + 意向价 × {{ ((1-selectedDetail.w) * 100).toFixed(0) }}%
                </div>
                <div class="formula-note">
                  <strong>商务得分计算：</strong><br>
                  投标价高于基准价：商务得分 = 100 - (投标价 - 基准价) / 单位价格<br>
                  投标价低于基准价：商务得分 = 100 + 2 × (基准价 - 投标价) / 单位价格<br>
                  <strong>总得分 = 资信得分 × 20% + 技术得分 × 20% + 商务得分 × 60%</strong>
                </div>
              </div>
            </template>
          </Alert>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import UTIL from '@/utils'
import mixinPageState from '@/mixins/page_state'
export default {
    mixins:[mixinPageState],
    data(){
        return {
            bid_eval_method:1,
            bid_price_type:1,
            limit_prices:[0,0],
            max_price:0,
            bidders:[],
            unit:0,
            bid_prices:[],
            orderBy:'rate',
            next_lowest_price:0,
            predict_columns:[],
            predict_data:[],
            score_data:{},
            showDetailModal: false,
            selectedDetail: null,
            detailTableData: [],
            pageStateFields:['bid_eval_method','bid_price_type','limit_prices','max_price','bidders']
        }
    },
    computed:{
        weights(){
            return [0.3,0.32,0.34,0.36,0.38,0.4,0.42,0.44,0.46,0.48,0.5]
        },
        precision(){
            return this.bid_price_type == 1 ? 10 : 1000
        },
        columns(){
            return [
                {type:'index',width:80,title:'序号'},
                {
                    title: '投标单位',
                    key: 'name'
                },
                {
                    title: '技术得分',
                    key: 'techScore'
                },
                {
                    title: '资信得分',
                    key: 'creditScore'
                },
                {
                    title: '商务报价',
                    key: 'bidPrice'
                }
            ]
        },
        detailColumns(){
            return [
                {type:'index',width:80,title:'排名'},
                {
                    title: '投标单位',
                    key: 'name',
                    minWidth: 200
                },
                {
                    title: '技术分',
                    key: 'techScore',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '资信分',
                    key: 'creditScore',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '商务报价',
                    key: 'bidPrice',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '商务分',
                    key: 'businessScore',
                    width: 120,
                    align: 'center',
                    render: (h, {row}) => {
                        // let raw = h('div',{style:'font-size:10px;color:#aaa;'}, row.raw_score.toFixed(2))
                        // let score =  h('div', {
                        //     style: {
                        //         color: row.isWinner ? '#f39c12' : '#333',
                        //         fontWeight: row.isWinner ? 'bold' : 'normal'
                        //     }
                        // }, row.businessScore.toFixed(0))
                        return h('div',{class:'flex-col align-center'}, [row.businessScore])
                    }
                },
                {
                    title: '总得分',
                    key: 'totalScore',
                    width: 120,
                    align: 'center',
                    render: (h, {row}) => {
                        return h('span', {
                            style: {
                                color: row.isWinner ? '#f39c12' : '#333',
                                fontWeight: row.isWinner ? 'bold' : 'normal',
                                fontSize: row.isWinner ? '16px' : '14px'
                            }
                        }, [
                            row.isWinner ? h('Icon', {
                                props: {
                                    type: 'md-trophy',
                                    size: 16
                                },
                                style: {
                                    marginRight: '4px'
                                }
                            }) : null,
                            row.totalScore.toFixed(2)
                        ])
                    }
                }
            ]
        }
    },
    mounted(){

    },
    methods:{
        __afterRestorePageState(){
            if(this.bidders.length == 0){
                this.loadTestData()
            }
        },
        parse(){
            let file = this.$refs.fileLoader.files[0];
      const that = this;
      this.loading = true;
      let bidders = [];
      UTIL.file2Xce(file, {header: 1})
          .then((tabJson) => {
            const map = {};
            const columns = {};
            console.log(tabJson)
            
            if (tabJson && tabJson.length > 0) {
              const items = tabJson[0].sheet;
              // 找到标题行和对应的列
              let startLine = 6;
              for (let i=startLine; i<items.length; i++) {
                const line = items[i];
                
                if (line.length == 0 || !line[1]) {
                  break;
                }

                if(this.bid_price_type == 2 && line[5] > 0){
                            this.Error("报价方式选择错误(当前为下浮率)，但表内的报价为金额，请检查")
                            return
                        }
                bidders.push({
                    id:i-startLine,
                    name:line[1],
                    techScore:line[3],
                    creditScore:line[4],
                    bidPrice:line[5],
                    businessScore:line[6] || 0,
                    totalScore:line[7] || 0})
                
               
              }

              this.bidders = bidders
              this.Success("数据加载完毕，自动计算")
              this.__savePageState()
              this.startPredict()
              
            } else {
              this.Error('excel表数据为空');
            }
          })
          .finally((e) => {
            that.$refs.fileLoader.value = '';
            this.loading = false;
          });
        },
        importExcel(){
            this.$refs.fileLoader.click();
        },
        formatNumber(n,precision){
            precision = precision == undefined?this.precision:precision
            if(!precision)
                return Math.round(n)
            return Math.round(n * precision) / precision
        },
        startPredict(){
            if(this.limit_prices[0]==0 || this.limit_prices[1]==0){
                this.Error('请输入价格区间')
                return
            }
            let difference = this.limit_prices[1] - this.limit_prices[0]
            if(difference < 0){
                this.Error('价格区间不能为负数')
                return
            }
            if(!this.max_price){
                this.Error('请输入最高限定价')
                return
            }
            this.unit = this.formatNumber(difference / 10)
            let bid_prices = [this.limit_prices[0]]
            
            for(let i=0; i<10; i++){
                let rate = this.formatNumber((this.limit_prices[0] + (i+1) * this.unit))
                bid_prices.push(rate)
            }
            this.bid_prices = bid_prices
         
            if(this.bid_eval_method == 1){

            }else{
                this.next_lowest_price = bid_prices[1]
            }

            const colors = ['#ffe','#fde','#fbd','#f9c','#f7b','#f5a','#f39','#f18','#ef7','#ed6','#eb5']
            this.predict_columns = this.weights.map((v,i)=>{
                return {
                    key:'weight'+i,
                    title:parseInt(v*100)+'%',
                    render:(h,{row})=>{
                        let score = this.score_data['weight'+i][row._index]
                        let color = UTIL.mapColor(row['weight'+i],30000)
                        return h('div',{
                            class:'bidder-card',
                            style:`width:100%;height:100%;color:#333;background:${color}22;text-align:left;padding:5px;cursor:pointer;`,
                            on:{
                                click:()=>{
                                    this.showBidderDetail(score)
                                }
                            }
                        },row['weight'+i])
                    }
                }
            })
            this.predict_columns.unshift({
                key:'rate',
                title:this.bid_price_type == 1 ? '投标评审价' : '下浮率',
                width:100
            })
            this.predict_columns.unshift({
                key:'id',
                title:'序号',
                type:'index',
                width:80
            })
            let predict_data = []
            let score_data = {}
            let base_price = 0
            let scores = []

            let total_price = 0
            this.bidders.forEach(b=>{
                total_price += b.bidPrice
            })
            this.average_price = total_price / this.bidders.length

            for(let i=0;i<this.weights.length;i++){
                let w = this.weights[i]
                score_data['weight'+i] = []
                for(let j=0;j<this.bid_prices.length;j++){
                   
                    let p = this.bid_prices[j]
                    if(this.bid_eval_method == 1){
                        base_price = this.average_price * w + p * (1-w)
                    }else{
                        base_price = this.average_price * w/2 + this.next_lowest_price*w/2+p*(1-w)
                    }
                    base_price = this.formatNumber(base_price)
                    let tmp_scores = {
                        w,
                        p,
                        base_price,
                        bidders:[]
                    } 
                    scores = []
                    let max_score = 0
                    let max_index = 0
                    this.bidders.forEach((bidder,k)=>{
                       
                        let b = bidder.bidPrice
                        if(this.bid_price_type == 2 && b > 0){
                            this.Error("报价方式选择错误(当前为下浮率)，但表内的报价为金额，请检查")
                            return
                        }
                        let bs = b > base_price ? (100 + 2*(base_price-b)/this.unit) : (100 - 1 * ( base_price - b)/this.unit)
                        let ibs = this.formatNumber(bs,1000)
                        scores.push(ibs)
                        tmp_scores.bidders.push({name:bidder.name,score:ibs,raw_score:ibs})
                        bidder.total = this.formatNumber(0.2*bidder.techScore + 0.2 * bidder.creditScore + 0.6*ibs,1000)
                        if(max_score < bidder.total){
                            max_score = bidder.total
                            max_index = k
                        }
                    })
                    let bidder = this.bidders[max_index].name
                    if(!predict_data[j]){
                        predict_data[j] = {id:'row_'+j,rate:p,["weight"+i]:bidder || ''}
                    }else{
                        predict_data[j]["weight"+i] = bidder || ''
                    }
                    score_data['weight'+i][j] = tmp_scores
                }
              
            }
            console.log(predict_data)
            this.score_data = score_data
            this.predict_data = predict_data
        },
        loadTestData(showAlert = true) {
            // 基于实际项目投标数据
            let testBidders = [
                {
                    name: "宁波时代建设监理有限公司",
                    techScore: 93.42,
                    creditScore: 98.8,
                    bidPrice: 1312687,
                    
                    description: "序号1投标单位"
                },
                {
                    name: "宁波诚建监理咨询有限公司",
                    techScore: 94.58,
                    creditScore: 99.6,
                    bidPrice: 1341000,
                    description: "序号2投标单位"
                },
                {
                    name: "宁波市天正工程咨询有限公司",
                    techScore: 93.74,
                    creditScore: 98.4,
                    bidPrice: 1320571,
                    description: "序号3投标单位"
                },
                {
                    name: "宁波高专建设监理有限公司",
                    techScore: 95.3,
                    creditScore: 100.0,
                    bidPrice: 1332801,
                    description: "序号4投标单位 - 中标单位"
                },
                {
                    name: "浙江华综工程项目管理有限公司",
                    techScore: 93.32,
                    creditScore: 98.8,
                    bidPrice: 1317354,
                    description: "序号5投标单位"
                },
                {
                    name: "宁波广天建设工程管理有限公司",
                    techScore: 93.76,
                    creditScore: 98.8,
                    bidPrice: 1339609,
                    description: "序号6投标单位"
                },
                {
                    name: "浙江华景工程管理有限公司",
                    techScore: 93.32,
                    creditScore: 98.4,
                    bidPrice: 1343259,
                    description: "序号7投标单位"
                },
                {
                    name: "浙江中铁科工程咨询有限公司",
                    techScore: 93.74,
                    creditScore: 98.8,
                    bidPrice: 1311078,
                    description: "序号8投标单位"
                },
                {
                    name: "浙江工正工程管理有限公司",
                    techScore: 94.3,
                    creditScore: 98.8,
                    bidPrice: 1333333,
                    description: "序号9投标单位"
                },
                {
                    name: "宁波国际投资咨询有限公司",
                    techScore: 95.74,
                    creditScore: 100.0,
                    bidPrice: 1346800,
                    description: "序号10投标单位"
                },
                {
                    name: "浙江元正工程管理有限公司",
                    techScore: 94.72,
                    creditScore: 96.8,
                    bidPrice: 1325295,
                    description: "序号11投标单位"
                }
            ];

            this.max_price = 1609080
            this.limit_prices = [1287264,1367718]
           

            // 清空现有数据
            let bidders = [];
            
            // 添加测试数据
            testBidders.forEach((testBidder, index) => {

                const bidder = {
                    id: Date.now() + index,
                    name: testBidder.name,
                    techScore: testBidder.techScore,
                    creditScore: testBidder.creditScore,
                    bidPrice: testBidder.bidPrice
                };
                bidders.push(bidder);
            });

            if(this.bid_price_type == 2){
                this.limit_prices = this.limit_prices.map(v=>this.formatNumber(v/this.max_price-1))
                bidders.forEach(v=>{
                    v.bidPrice = this.formatNumber(v.bidPrice/this.max_price-1)
                })
            }

           
            this.bidders = bidders
        },
        showBidderDetail(score){
            this.selectedDetail = score
            
            // 计算每个投标单位的商务得分和总得分
            const tableData = []
            let maxTotalScore = 0
            let winnerIndex = -1
            
            this.bidders.forEach((bidder, index) => {
                // 获取当前投标单位的商务得分
                const businessScore = score.bidders[index].score
                
                // 计算总得分: 资信分*0.2 + 技术分*0.2 + 商务分*0.6
                const totalScore = bidder.creditScore * 0.2 + bidder.techScore * 0.2 + businessScore * 0.6
                
                if (totalScore > maxTotalScore) {
                    maxTotalScore = totalScore
                    winnerIndex = index
                }
                
                tableData.push({
                    id: bidder.id,
                    name: bidder.name,
                    techScore: bidder.techScore,
                    creditScore: bidder.creditScore,
                    bidPrice: bidder.bidPrice,
                    businessScore: businessScore,
                    totalScore: totalScore,
                    isWinner: false
                })
            })
            
            // 标记得分最高的单位
            if (winnerIndex >= 0) {
                tableData[winnerIndex].isWinner = true
            }
            
            this.detailTableData = tableData
            this.showDetailModal = true
        },
        getMaxScore(bidders){
            if(!bidders || bidders.length === 0) return 0
            return Math.max(...bidders.map(b => b.score))
        },
        formatPrice(price){
            if(this.bid_price_type == 2){
                return (price * 100).toFixed(2) + '%'
            }
            return price.toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        }

    }
}
</script>

<style lang="less">
.bid-predict-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  letter-spacing: 2px;
}

.page-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 300;
  letter-spacing: 1px;
}

.config-section,
.bidders-section,
.predict-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.config-section:hover,
.bidders-section:hover,
.predict-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8ecf1;
}

.section-title i {
  color: #667eea;
}

.config-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-row-flex {
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
}

.config-item-inline {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-label {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 4px;
}

.input-range {
  display: flex;
  align-items: center;
  gap: 12px;
}

.range-separator {
  color: #909399;
  font-weight: 500;
}

.input-custom {
  flex: 1;
  width:200px;
}

.radio-group-custom {
  display: flex;
  gap: 16px;
}

.radio-group-vertical {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.formula-text {
  font-size: 14px;
  color: #606266;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  display: inline-block;
  margin-left: 8px;
}

.table-wrapper {
  overflow: auto;
}

.predict-control {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}

.predict-btn {
  padding: 12px 48px;
  font-size: 16px;
  font-weight: 600;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.predict-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.results-container {
  margin-top: 24px;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.result-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.result-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  transition: all 0.3s ease;
}

.result-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.bidder-card:hover{
   background:var(--primary) !important;
   color:var(--hover-text) !important;
   transition:background 0.3s;
}
.card-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 8px;
  font-weight: 500;
}

.card-value {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
}

.result-detail {
  background: #f5f7fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #667eea;
}

.detail-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
  font-weight: 600;
}

.detail-value {
  font-size: 14px;
  color: #303133;
  font-family: 'Courier New', monospace;
  word-break: break-all;
}

.predict-table-wrapper {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
  .ivu-table-cell,.ivu-tooltip,.ivu-tooltip-rel{
    position:relative;
    height:100% !important;
    display:flex;
    align-items: center;
    justify-content: center;
  }
}

/* 滚动条美化 */
.bid-predict-container::-webkit-scrollbar,
.predict-table-wrapper::-webkit-scrollbar,
.table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.bid-predict-container::-webkit-scrollbar-track,
.predict-table-wrapper::-webkit-scrollbar-track,
.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.bid-predict-container::-webkit-scrollbar-thumb,
.predict-table-wrapper::-webkit-scrollbar-thumb,
.table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.bid-predict-container::-webkit-scrollbar-thumb:hover,
.predict-table-wrapper::-webkit-scrollbar-thumb:hover,
.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .bid-predict-container {
    max-width: 100%;
  }
}

/* 平板适配 */
@media (max-width: 1024px) {
  .bid-predict-container {
    padding: 16px;
  }

  .config-row-flex {
    flex-direction: column;
    gap: 16px;
  }

  .input-custom {
    width: 100% !important;
  }
}

/* 手机端适配 */
@media (max-width: 768px) {
  .bid-predict-container {
    padding: 8px;
    max-width: 100%;
  }

  .page-title {
    font-size: 20px;
    letter-spacing: 1px;
  }

  .page-subtitle {
    font-size: 12px;
  }

  .page-header {
    padding: 12px;
    margin-bottom: 16px;
  }

  .config-section,
  .bidders-section,
  .predict-section {
    padding: 12px;
    margin-bottom: 12px;
    overflow:hidden;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .config-container {
    gap: 12px;
  }

  .config-row {
    gap: 6px;
  }

  .config-row-flex {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .config-label {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .input-custom {
    width: 100% !important;
  }

  .radio-group-custom {
    gap: 12px;
  }

  .radio-group-vertical {
    gap: 8px;
  }

  .formula-text {
    font-size: 12px;
    padding: 6px 8px;
    word-break: break-all;
    white-space: normal;
  }

  .result-cards {
    grid-template-columns: 1fr;
  }

  .input-range {
    flex-direction: row;
    gap: 8px;
  }

  .input-range .input-custom {
    min-width: 0;
  }

  .range-separator {
    flex-shrink: 0;
  }

  .predict-btn {
    padding: 10px 32px;
    font-size: 14px;
    width: 100%;
  }

  .table-wrapper {
    font-size: 12px;
  }

  .predict-table-wrapper {
    font-size: 12px;
  }

  .overview-card {
    padding: 12px;
  }

  .overview-label {
    font-size: 12px;
  }

  .overview-value {
    font-size: 20px;
    
    &.highlight {
      font-size: 22px;
    }
  }

  .detail-overview {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .detail-table-wrapper {
    height: 400px;
  }

  .bidder-detail-modal .ivu-modal {
    width: 95% !important;
    margin: 10px auto;
  }
}

/* 超小屏幕优化 */
@media (max-width: 450px) {
  .bid-predict-container {
    padding: 6px;
  }

  .page-title {
    font-size: 18px;
  }

  .page-subtitle {
    font-size: 11px;
  }

  .config-section,
  .bidders-section,
  .predict-section {
    padding: 10px;
  }

  .section-title {
    font-size: 14px;
  }

  .config-label {
    font-size: 12px;
  }

  .formula-text {
    font-size: 11px;
    padding: 4px 6px;
  }

  .predict-btn {
    padding: 8px 24px;
    font-size: 13px;
  }

  .input-range {
    flex-wrap: wrap;
  }

  .ivu-radio-wrapper {
    font-size: 13px;
  }

  .ivu-input {
    font-size: 13px;
  }

  .config-item-inline {
    min-width: 0;
  }
}

/* 全局移动端优化 */
@media (max-width: 768px) {
  .bid-predict-container .ivu-table {
    font-size: 12px;
  }

  .bid-predict-container .ivu-table-cell {
    padding: 6px 4px;
  }

  .bid-predict-container .ivu-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .bid-predict-container .ivu-radio-wrapper {
    margin-right: 12px;
  }

  .bid-predict-container .ivu-input-number {
    width: 100%;
  }

  .bid-predict-container .ivu-input-number-input {
    padding: 4px 8px;
  }

  .bid-predict-container .flex-wrap.flex-between {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .bid-predict-container .flex-wrap.flex-between .ivu-btn {
    width: 100%;
  }

  .bid-predict-container .table-wrapper {
    height: 300px !important;
  }
}

/* 对话框样式 */
.bidder-detail-modal {
   
  .ivu-modal-header {
    border-bottom: none;
    padding: 24px 24px 0;
  }
  
  .ivu-modal-body {
    padding: 20px 24px 24px;
    overflow:hidden;
    margin-bottom:25px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  
  i {
    color: #667eea;
  }
}

.modal-content {
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detail-overview {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.overview-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
  }
}

.overview-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 8px;
  font-weight: 500;
}

.overview-value {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  
  &.highlight {
    font-size: 32px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}

.detail-section {
  margin-bottom: 24px;
}

.detail-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e8ecf1;
  
  i {
    color: #f39c12;
  }
}

.detail-table-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8ecf1;
  height: 500px;
  overflow-y: auto;
  position:relative;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  .ivu-table {
    font-size: 14px;
    
   
  }
}

.detail-footer {
  margin-top: 24px;
  
  .ivu-alert {
    border-radius: 8px;
  }
}

.formula-info {
  font-size: 13px;
  line-height: 1.8;
  
  strong {
    color: #2c3e50;
  }
}

.formula-text-detail {
  background: #f5f7fa;
  padding: 8px 12px;
  border-radius: 6px;
  margin: 8px 0;
  font-family: 'Courier New', monospace;
  color: #606266;
  border-left: 3px solid #667eea;
}

.formula-note {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e8ecf1;
}
</style>